import { render, staticRenderFns } from "./Setting_Period.vue?vue&type=template&id=c6c6c65a&scoped=true"
import script from "./Setting_Period.vue?vue&type=script&lang=js"
export * from "./Setting_Period.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6c6c65a",
  null
  
)

export default component.exports